module.exports = __webpack_public_path__ + "static/img/title-1.d9be94a4.png";